import { conditionalBranchMessage } from '../functions'

export default {
  function: {
    upload_common: {
      conditional_branch_message: (args: any) =>
        conditionalBranchMessage(args, (triggerQuestionSelectMetaList) => {
          const messages = triggerQuestionSelectMetaList.map(
            ({ categoryName, questionDisplayNumber, selectText }) => {
              return `「${categoryName}」の${questionDisplayNumber}問目で「${selectText}」`
            }
          )
          return `${messages.join('、または')}と回答した方にお伺いします（必須回答）`
        }),
    },
    validation: {
      decimal_max_digit: '小数点第{decimalMaxDigit}位までで入力してください。',
    },
  }
}
